import { useEffect, useRef, useState, useCallback } from 'react';
import ReactDOM from 'react-dom';

const FloatingActionsContainer = ({ children }) => {
  const containerRef = useRef(null);
  const [isStopped, setIsStopped] = useState(false);
  const [bottomOffset, setBottomOffset] = useState('20px');
  const footerElementRef = useRef(null);

  // Эта функция в порядке, не трогаем
  const calculateBottomOffset = useCallback(() => {
    const footerElement = footerElementRef.current;
    if (!footerElement) return '20px';
    const desiredMarginFromFooter = 20;
    if (isStopped) {
      return `${footerElement.offsetHeight + desiredMarginFromFooter}px`;
    } else {
      return '20px';
    }
  }, [isStopped]);

  // === ГЛАВНЫЙ, СУКА, ФИКС. ДОБАВЛЯЕМ ПРОВЕРКУ ВЫСОТЫ ===
  useEffect(() => {
    let observer;
    let retryInterval; // Теперь это, блять, интервал, а не таймаут

    const findAndObserveFooter = (attempt = 1) => {
      // Ищем футер и проверяем высоту кнопок
      
      const footerQueryElement = document.querySelector('.js-stop-point');
      const floatingContainer = containerRef.current;

      // УСЛОВИЕ: Футер НАЙДЕН И, СУКА, ВЫСОТА КНОПОК БОЛЬШЕ НУЛЯ
      if (footerQueryElement && floatingContainer && floatingContainer.offsetHeight > 0) {
        
        clearInterval(retryInterval); // Убиваем нахуй наш интервал, он больше не нужен
        // Футер найден, запускаем слежку
        footerElementRef.current = footerQueryElement;

        const observerCallback = (entries) => {
          const entry = entries[0];
          if (!entry) return;

          const footerTop = entry.boundingClientRect.top;
          const stopPosition = window.innerHeight - floatingContainer.offsetHeight - 20;

          if (entry.isIntersecting && footerTop <= stopPosition) {
            if (!isStopped) setIsStopped(true);
          } else {
            if (isStopped) setIsStopped(false);
          }
        };

        observer = new IntersectionObserver(observerCallback, { threshold: [0, 1] });
        observer.observe(footerQueryElement);

      } else if (attempt >= 10) {
        // Если после 10 попыток нихуя не вышло
        clearInterval(retryInterval);       
      }
    };

    // Запускаем проверку каждые 300мс, пока не найдем все, что нужно
    retryInterval = setInterval(findAndObserveFooter, 300);

    // Функция очистки
    return () => {
      clearInterval(retryInterval); // Убиваем интервал
      if (observer) observer.disconnect(); // Убиваем шпиона
      // Интервал и Observer очищены
    };
  }, [isStopped]); // Оставляем isStopped, чтобы observer пересоздавался

  // ... остальной код без изменений ...
  useEffect(() => {
    setBottomOffset(calculateBottomOffset());
    const handleResize = () => setBottomOffset(calculateBottomOffset());
    window.addEventListener('resize', handleResize, { passive: true });
    return () => window.removeEventListener('resize', handleResize);
  }, [isStopped, calculateBottomOffset]);

  const floatingContent = (
    <div
    id="floating-actions-container-id"
      ref={containerRef}
      style={{
        position: isStopped ? 'absolute' : 'fixed',
        bottom: bottomOffset,
        right: '20px', 
        zIndex: 999,
        transition: 'bottom 0.4s ease',
        display: 'flex',
        flexDirection: 'column',
        gap: '15px',
      }}
    >
      {children}
    </div>
  );

  return ReactDOM.createPortal(floatingContent, document.body);
};

export default FloatingActionsContainer;